module.exports = __webpack_public_path__ + "static/four-steps-turorial-step-2-c27379e7bb227cdaffe8aec44e877a55.svg";